// next.config.ts sets trailingSlash: true; without the trailing slash the POST
// would be answered with a 308 redirect first.
const ENDPOINT = "/api/client-log/";

export function reportClientError(
  error: Error & { digest?: string },
  boundary: string,
): void {
  try {
    const payload = JSON.stringify({
      boundary,
      digest: error.digest,
      message: error.message,
      name: error.name,
      pathname: window.location.pathname,
      stack: error.stack,
    });

    const queued = navigator.sendBeacon?.(
      ENDPOINT,
      new Blob([payload], { type: "application/json" }),
    );
    if (!queued) {
      fetch(ENDPOINT, {
        body: payload,
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        method: "POST",
      }).catch(() => {
        // reporting must never surface errors to the user
      });
    }
  } catch {
    // reporting must never surface errors to the user
  }
}
